module.exports = __webpack_public_path__ + "static/media/close-grey.973f9f95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/close-grey.svg
// module id = 31
// module chunks = 0